import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { NAVIGATION_REQUEST, PROJECTS_REQUEST, PROJECT_CREATE_REQUEST, PROJECT_DELETE_REQUEST, PROJECT_EDIT_PAGE_REQUEST, PROJECT_UNITS_REQUEST, PROJECT_UNIT_CREATE_REQUEST, PROJECT_UNIT_DELETE_REQUEST, PROJECT_UNIT_EDIT_PAGE_REQUEST } from "../../redux/action_constant";
import WebService from "../../utility/WebService";
import API from "../../utility/API-endPoints";
import { projectUnitDeleteFailure, projectUnitDeleteSuccess, projectUnitEditPageSuccess, projectUnitsFailure, projectUnitsSuccess } from "./ProjectUnitAction";
import { ProjectEditPageRequest, ProjectUnitInterface, ProjectRequestPayload, ProjectsRequest, ProjectsRequestFailure, ProjectsRequestSuccessPayload, ProjectUnitState } from "./ProjectUnitTypes";
import routePaths from "../../Navigation/routePaths";
import { reduxInitialState } from "../onBoarding/onBoardingTypes";
import { toast } from "react-toastify";
import { navigationRequest } from "../../Navigation/NavigationRedux/NavigationRedux";

export const getProjectUnitReducer = (state: reduxInitialState) => state.ProjectUnitReducer;

const getProjetUnits = async (payload: ProjectRequestPayload) => {
    payload.page = payload.page ? (Number(payload.page) - 1) : 0;
    let query = new URLSearchParams(payload as any).toString();
    const data = await WebService.getAPI({
        action: API.PROJECT_UNITS_LIST + query,
        body: {},
    }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const deleteProjet = async (payload: string) => {
    const data = await WebService.deleteAPI({ action: API.PROJECT_UNIT_DELETE + payload, }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

const createOrUpdateProject = async (payload: ProjectUnitInterface) => {
    const isUpdate = payload.id ? true : false;
    const data = await WebService[isUpdate ? 'putAPI' : 'postAPI']({
        action: isUpdate ? API.PROJECT_UNIT_UPDATE : API.PROJECT_UNIT_CREATE,
        body: payload,
        id: 'project_create_update_btn'
    }).then((res: any) => res).catch((e: any) => { return null })
    return data;
};

function* projectRequestSaga(action: ProjectsRequest) {
    try {
        const response: ProjectsRequestSuccessPayload = yield call(getProjetUnits, action.payload);
        if (!response) { throw new Error(); }
        yield put(projectUnitsSuccess(response));
    } catch (e: any) {
        yield put(projectUnitsFailure(e.message));
    }
};

function* editProjectPageRequestSaga(action: ProjectEditPageRequest) {
    yield put(projectUnitEditPageSuccess(action.payload));
    yield put({ type: NAVIGATION_REQUEST, payload: routePaths.PROJECT_UNIT_UPDATE.path });
};

function* deleteProjectRequestSaga(action: ProjectsRequestFailure) {
    try {
        const data: ProjectUnitState = yield select(getProjectUnitReducer);
        const uuid = data.deleteProject.uuid;
        const response: { message: string } = yield call(deleteProjet, uuid);
        toast.success(response.message);
        if (!response) { throw new Error(); };
        yield put(projectUnitDeleteSuccess());
        try {
            const projectResponse: ProjectsRequestSuccessPayload = yield call(getProjetUnits, { page: 1, id: action.payload });
            if (!projectResponse) { throw new Error(); }
            yield put(projectUnitsSuccess(projectResponse));
        } catch {
            yield put(projectUnitsFailure('Failed to fetch project list'));
        }
    } catch {
        yield put(projectUnitDeleteFailure());
    }
};

function* createOrUpdateProjectRequestSaga(action: ProjectEditPageRequest) {
    try {
        const response: { message: string } = yield call(createOrUpdateProject, action.payload);
        if (!response) { throw new Error(); }
        toast.success(response.message);
        yield put(navigationRequest('-1'));
    } catch {
        toast.error('Failed to create project');
    }
};

function* ProjectUnitSaga() {
    yield all([takeLatest(PROJECT_UNITS_REQUEST, projectRequestSaga)]);
    yield all([takeLatest(PROJECT_UNIT_EDIT_PAGE_REQUEST, editProjectPageRequestSaga)]);
    yield all([takeLatest(PROJECT_UNIT_DELETE_REQUEST, deleteProjectRequestSaga)]);
    yield all([takeLatest(PROJECT_UNIT_CREATE_REQUEST, createOrUpdateProjectRequestSaga)]);
};

export default ProjectUnitSaga;